import TaskStast from './TaskStats'
import PinnedTasks from './PinnedTasks'


const PinnedAndStats = () => {

    return(
        <>
            <PinnedTasks />
            <TaskStast />
        </>
    )
}
export default PinnedAndStats